'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegulatorService = function () {
  function RegulatorService($http) {
    'ngInject';

    _classCallCheck(this, RegulatorService);

    this.$http = $http;
  }

  _createClass(RegulatorService, [{
    key: 'getDefaultQuery',
    value: function getDefaultQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        orderBy: 'AgentName',
        direction: 'asc'
      });
    }
  }, {
    key: 'get',
    value: function get(id) {
      return this.$http.get('/api/regulator/' + id);
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete('/api/regulator/' + id);
    }
  }, {
    key: 'add',
    value: function add(regulator) {
      return this.$http.post('/api/regulator', regulator);
    }
  }, {
    key: 'update',
    value: function update(regulator) {
      return this.$http.put('/api/regulator/' + regulator.RegulatorId, regulator);
    }
  }, {
    key: 'search',
    value: function search(query) {
      return this.$http.get('/odata/RegulatorOData', {
        params: _extends({
          $select: 'RegulatorId, AgentName',
          $top: query.take,
          $skip: query.calculateSkip(),
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }]);

  return RegulatorService;
}();

exports.default = RegulatorService;


// WEBPACK FOOTER //
// ./services/regulator.service.js